import Vue from "vue";
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        userInfo: {
            id: '',
            account: '',
            mail: '',
            phone: '',
            avatar: '',
            createTime: '',
        },
        permissionList: {
            curriculumAdmin: false,
            fullAdmin: false,
            normalUser: false,
            propertyAdmin: false,
            userAdmin: false
        }
    },
    mutations: {
        userInfoReceive(state, userInfo) {
            state.userInfo = userInfo;
        },
    },
});